import { createTheme } from '@mui/material';

export const theme = createTheme({
  shape: {
    borderRadius: 7
  },
  palette: {
    mode: 'light',
    primary: {
      light: '#B7FDA3',
      main: '#75CD7F',
      dark: '#274037'
    },
    background: {
      default: '#FAF5F0'
    }
  },
  typography: {
    fontFamily: 'Istok Web, serif',
    body1: {
      fontSize: '1.125rem'
    },
    body2: {
      fontSize: '1rem'
    },
    h1: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    },
    h2: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    },
    h3: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    },
    h4: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    },
    h5: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    },
    h6: {
      fontFamily: 'Poppins, serif',
      fontStyle: 'normal'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  }
});
